import { DefaultComparisonOption } from '@app/models/default-comparison-option';
import { Language } from '@app/models/language';
import { User } from '@app/models/user';
import { Filter, TrainType, UserFilter } from '@app/pcs/models';
import { UserNotification } from '@app/pcs/settings/models/user-notification';
import * as R from 'ramda';

export interface PersonalSettings {
  language?: Language;
  defaultFilter?: Filter;
  userFilters?: UserFilter[];
  emailNotifications?: UserNotification[];
  subscribedTrainTypes?: TrainType[];
  defaultPageSize?: number;
  defaultDossierView?: string;
  defaultTrainType?: TrainType;
  defaultComparisonOption?: DefaultComparisonOption;
  dossierSideMenuCollapsed?: boolean;
  fullScreenMode?: boolean;
}

type GetFullScreenMode = (user: User) => boolean;
export const getFullScreenMode: GetFullScreenMode = R.path(['personalSettings', 'fullScreenMode']);
